import React,{Fragment} from 'react';
import './index.scss';
import DataGrid, {
    Column,
    Editing,
    Popup,
    Paging,
    Position,
    Form,
    Lookup 
} from 'devextreme-react/data-grid';
import  {
    Item,
    RequiredRule,
    Label
} from 'devextreme-react/form';
import CustomStore from 'devextreme/data/custom_store';
import StatesService from '../../../../utils/states';
import CountryService from '../../../../utils/country';
import url from '../../../../api/base-url';
import sessions from '../../../../sessions';
import 'whatwg-fetch';

export default function ShipsFromLocation(){
    const userId = sessions.getSession("user")?.id;
    const auth = sessions.getSession("user")?.accessToken;
    const CountryOnChange = (newData, value, currentRowData) => {
        console.log("countryOnChange",newData, value, currentRowData);
        newData.state = null;
        newData.country = value;
        //rowData.state = null;
        //rowData.country = value;
        //this.defaultSetCellValue(rowData, value);
    }

    const getFilteredState = (options) =>{
        return {
          store: StatesService,
          filter: options.data ? ['country_code', '=', options.data.country] : null,
          pageSize: 10,
          paginate: true
        };
    }

    const getCountry = () => {
        return{
          store: CountryService,
          pageSize: 10,
          paginate: true
        }
    }

    const onEditorPreparing = (e) => {
        if(e.parentType === "dataRow" && e.dataField === "state") {
            e.editorOptions.disabled = !e.row.data.country;
        }
    };

    function getConfig(options) {  
        options.onBeforeSend = function(method, ajaxOptions) {  
            ajaxOptions.headers = {  
               "x-access-token": auth
            }  
        }  
        return options;  
    };

    const addressDataSource =new CustomStore(getConfig({
        key: '_id', 
        load: () => {
            return fetch(`${url}/settings/warehouses/${encodeURIComponent(userId)}`,
            {
                headers: {
                    "x-access-token": auth
                }
            }).then(response => response.json());
        },
        insert: (values) => {
            return fetch(`${url}/setting/warehouse/insert/${encodeURIComponent(userId)}`,
            {
                method: "POST",
                body: JSON.stringify(values),
                headers: {
                    'Content-Type': 'application/json',
                    "x-access-token": auth
                }
            })
        },
        update: (key,values) => {
            return fetch(`${url}/setting/warehouse/update/${encodeURIComponent(key)}`,
            {
                method: "PUT",
                body: JSON.stringify(values),
                headers: {
                    'Content-Type': 'application/json',
                    "x-access-token": auth
                }
            })
        },
        remove: (key) =>{
            return fetch(`${url}/setting/warehouse/delete/${encodeURIComponent(key)}`,
            {
                method: "DELETE",
                headers: {
                    'Content-Type': 'application/json',
                    "x-access-token": auth
                }
            })
        } 
    }));

    const textBoxOptions = {
        stylingMode:'filled',
        height:40,
        margin:0,
        padding:0,
    }

    return(
        <Fragment>
        <h4 className={'content-block'}>Ship From Locations</h4>
        <div className={'content-block'}>
            <DataGrid dataSource={addressDataSource} onEditorPreparing={onEditorPreparing} wordWrapEnabled={true}>
            <Paging enabled={true} />
            <Editing mode="popup" allowUpdating={true} allowDeleting={true} allowAdding={true}>
                <Popup title="Address" showTitle={true} width={700} height={525}>
                    <Position my="top" at="top" of={window} />
                </Popup>
                <Form id="address" colCount={2}>
                    <Item dataField={'name'} editorOptions={textBoxOptions}>
                        <RequiredRule message="name is required"/>
                    </Item>
                    <Item dataField={'country'} editorOptions={{ stylingMode:'filled',height: 40}}>
                        <RequiredRule message="name is required"/>
                    </Item>
                    <Item dataField={'state'} editorOptions={{ stylingMode:'filled',height: 40}}>
                        <RequiredRule message="name is required"/>
                    </Item>
                    <Item dataField={'city'} editorOptions={textBoxOptions}>
                        <RequiredRule message="name is required"/>
                    </Item>
                    <Item dataField={'street1'} editorOptions={textBoxOptions}>
                        <RequiredRule message="name is required"/>
                    </Item>
                    <Item dataField={'zipCode'} editorOptions={textBoxOptions}>
                        <RequiredRule message="name is required"/>
                    </Item>
                    <Item editorType={'dxCheckBox'} dataField={'isDefaultLocation'} editorOptions={{defaultValue:false,value:false}}>
                        <Label text={'Is this your default location?'}/>
                    </Item>
                    <Item editorType={'dxCheckBox'} dataField={'isRedentialAddress'} editorOptions={{defaultValue:false,value:false}}>
                        <Label text={'Is this redential address?'}/>
                    </Item>
                </Form>
            </Editing>
                <Column dataField={'name'}/>
                <Column dataField={'isDefaultLocation'} caption={'Main Address'}/>
                <Column dataField={'street1'}/>
                <Column dataField={'city'}/>
                <Column dataField={'state'}>
                    <Lookup dataSource={getFilteredState} displayExpr={'name'} valueExpr={'name'}/>
                </Column>
                <Column dataField={'country'} setCellValue={CountryOnChange}>
                    <Lookup dataSource={getCountry} displayExpr={'name'} valueExpr={'iso2'}/>
                </Column>
                <Column dataField={'zipCode'}/>
                <Column dataField={'isRedentialAddress'} caption={'Home Address'}/>
            </DataGrid>
        </div>
    </Fragment>
    )
};